var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"union-checkbox",class:[{'checked':!_vm.isDisabled && _vm.isChecked},{'disabled':_vm.isDisabled}],on:{"click":_vm.handle}},[_c('span',{staticClass:"mark"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.optionKey))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0868fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/checkbox.vue
// module id = 8R0S
// module chunks = 0